import { useState, type FormEvent } from 'react';

export default function CTASection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [statusMessage, setStatusMessage] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = (formData.get('phone_alt') as string || '').trim();
    if (honeypot) {
      setStatus('success');
      setStatusMessage('订阅成功！感谢您的关注。');
      setEmail('');
      return;
    }

    setStatus('loading');

    try {
      const body = new URLSearchParams();
      body.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d9nfg6gbdkpk99j7giqg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });

      const responseText = await response.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string }; message?: string } = {};
      try {
        parsed = JSON.parse(responseText);
      } catch {
        // ignore parse error
      }

      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setStatusMessage('订阅成功！感谢您的关注，最新影视资讯将第一时间送达。');
        setEmail('');
      } else {
        if (typeof serverMsg === 'string' && serverMsg.toLowerCase().includes('spam')) {
          setStatus('success');
          setStatusMessage('订阅成功！感谢您的关注。');
          setEmail('');
        } else {
          setStatus('error');
          setStatusMessage(typeof serverMsg === 'string' ? serverMsg : '订阅失败，请稍后再试。');
        }
      }
    } catch {
      setStatus('error');
      setStatusMessage('网络错误，请检查网络后重试。');
    }
  };

  return (
    <section className="py-14 bg-accent-500 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-accent-600/20 to-transparent"></div>
      <div className="container-custom relative z-10">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-background-50 mb-3">
            不错过任何精彩
          </h2>
          <p className="text-sm text-background-50/80 mb-8 leading-relaxed">
            订阅番茄视频资讯，第一时间获取最新影视上线、热门推荐和独家观影福利
          </p>

          <form
            onSubmit={handleSubmit}
            data-readdy-form
            className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
          >
            <input
              type="text"
              name="phone_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="honeypot-field"
            />
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="请输入您的邮箱地址"
              required
              className="flex-1 px-5 py-3.5 rounded-full bg-background-50 text-foreground-900 placeholder:text-foreground-400 text-sm outline-none focus:ring-2 focus:ring-background-50/50"
            />
            <button
              type="submit"
              disabled={status === 'loading'}
              className="px-8 py-3.5 bg-foreground-950 text-background-50 font-semibold rounded-full text-sm whitespace-nowrap hover:bg-foreground-900 transition-colors duration-200 cursor-pointer disabled:opacity-60"
            >
              {status === 'loading' ? '提交中...' : '立即订阅'}
            </button>
          </form>

          {status !== 'idle' && (
            <p className={`mt-4 text-sm ${status === 'success' ? 'text-background-50' : 'text-background-50/80'}`}>
              {statusMessage}
            </p>
          )}

          <p className="mt-4 text-xs text-background-50/50">
            我们尊重您的隐私，不会发送垃圾邮件
          </p>
        </div>
      </div>
    </section>
  );
}